import { defineComponent as _defineComponent } from 'vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import ActivityPanel from "./ActivityPanel.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InputPanel',
    props: {
        inputs: null
    },
    emits: ["insertModule"],
    setup(__props, { emit }) {
        const props = __props;
        return { __sfc: true, props, emit, FontAwesomeIcon, ActivityPanel };
    }
});
